export default "__VITE_ASSET__DOh7gcJD__"